'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Link, usePathname } from '@/i18n/navigation';
import { MapPinIcon, PackageIcon, ShoppingCartIcon, UserIcon } from 'lucide-react';
import { useTranslatedRoute } from '@/hooks';
const UserNavigation = () => {
  const $ = _c(4);
  const t = useTranslations();
  const pathname = usePathname();
  const {
    buildRoute
  } = useTranslatedRoute();
  let t0;
  if ($[0] !== buildRoute || $[1] !== pathname || $[2] !== t) {
    const items = [{
      label: t("profile"),
      href: buildRoute("/profile"),
      icon: UserIcon
    }, {
      label: t("addresses"),
      href: buildRoute("/addresses"),
      icon: MapPinIcon
    }, {
      label: t("shopping_cart"),
      href: buildRoute("/cart"),
      icon: ShoppingCartIcon
    }, {
      label: t("orders"),
      href: buildRoute("/orders"),
      icon: PackageIcon
    }];
    t0 = <ul className="flex w-full flex-row gap-1 rounded-lg bg-gray-100 p-1 text-sm font-medium">{items.map((item, key) => <li key={key} className="flex-auto"><Link href={item.href} className={`flex flex-row items-center justify-center gap-1.5 rounded-md bg-gray-100 px-4 py-3 text-gray-500 transition-all duration-300 hover:bg-gray-200 hover:text-gray-700 md:px-8 ${pathname.startsWith(item.href) ? "bg-brand! hover:bg-brand-darken! text-white hover:text-white!" : ""}`}><item.icon className="h-3.5 w-3.5 shrink-0" /><span className="hidden sm:inline">{item.label}</span></Link></li>)}</ul>;
    $[0] = buildRoute;
    $[1] = pathname;
    $[2] = t;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
export default UserNavigation;